import type { ApiCommand } from '../api/apiCommand';
import type { BackendClient } from './backendClient';
import { getPath } from '../util/getPath';
import { unknownBody } from './assumeResult';

/**
 * Send a command as an HTTP request to the Mimir backend, and interpret the
 * response as command output.
 */
export async function sendApiCommand<OutputType>(backend: BackendClient, command: ApiCommand<OutputType>): Promise<OutputType> {
  const links = backend.getServiceLinks();
  const apiClient = backend.getApiClient();
  const config = apiClient.config();
  const req = command.request();
  const result = await apiClient.call(config, getPath(links[req.linkName], req.pathParams), req.method, {
    queryParams: req.queryParams
  }, req.body);
  return command.asOutput(unknownBody(result));
}
